import React, { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import MolGrid from '../../../components/Grid/MolGrid';
import CenterModel from '../../../components/ui/centerModel/CenterModel';
import { individualMemberTasklistTableConfig } from '../data/IndividualMemberTable.Data';
import { useGetIndividualTaskListMutation } from '../../../app/services/Individual/IndividualTaskListApi';
import { encryptAESID } from '../../../utils/Encryption';
import ToastService from '../../../services/toastService/ToastService';
import { useLazyDeleteMemberQuery } from '../../../app/services/Common/CommonApi';
import SwalAlert from '../../../services/swalService/SwalService';
import { getAuthProps } from '../../../lib/authenticationLibrary';

const IndividualMemberTable = ({ paginationReq }) => {
    const navigate = useNavigate();
    const molGridRef = useRef();
    const { confirm, error, success, confirmDelete } = SwalAlert();
    const [dataSource, setDataSource] = useState();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loginAdminId, setLoginAdminId] = useState("");
    const [paginationRequest, setPaginationRequest] = useState({
        pageNo: 1,
        pageSize: 10,
        endPage: 100,
        SearchText: "",
        gmapNumber: "",
        submissionStartDate: "",
        submissionEndDate: "",
        totalCount: 0,
        StatusId: null
    });

    const [memberTaskList,
        { isSuccess: isSuccess,
            isLoading: isLoading,
            data: memberTaskResponse },
    ] = useGetIndividualTaskListMutation();

    const [deleteRecord, {
        data: deleteResponse,
        isSuccess: isDeleteSuccess,
        isLoading: isDeleteLoading,
    }] = useLazyDeleteMemberQuery()

    // useEffect(() => {
    //     memberTaskList(paginationReq)
    // }, [])

    useEffect(() => {
        let loginData = getAuthProps();
        setLoginAdminId(loginData.adminUserId);
        setDataSource([]);
        memberTaskList(paginationReq)
        setPaginationRequest(paginationReq);
    }, [paginationReq])

    useEffect(() => {
        if (!isLoading && isSuccess && memberTaskResponse) {
            setPaginationRequest({ ...paginationRequest, totalCount: memberTaskResponse.totalCount })
            setDataSource(memberTaskResponse.itemList)
        }
    }, [isLoading, isSuccess, memberTaskResponse]);

    useEffect(() => {
        if (!isDeleteLoading && isDeleteSuccess && deleteResponse) {
            ToastService.success("Delete Item successfully");
            memberTaskList(paginationReq)
        }
    }, [isDeleteLoading, isDeleteSuccess, deleteResponse])

    const handlePageChange = ({ pageNumber, pageSize }) => {
        memberTaskList({ ...paginationRequest, pageNo: pageNumber, pageSize: pageSize })
    }

    const handleViewClick = (memberID) => {
        navigate(`/individualMember/${encryptAESID(memberID)}`);
    }

    const handleCustomActionClick = (rowData, buttonName) => {
        if (buttonName === "Delete") {
            handleTableDelete(rowData?.taskId)
        } else {
            handleViewClick(rowData?.individualMemberId)
        }
    };
    const handleTableDelete = (taskId) => {
        const request = {
            id: taskId,
            isCorporateMember: false,
            isAcademicMember: false,
            deletedBy: loginAdminId,
        }
        confirmDelete("Are you sure?", "Type 'delete' to confirm", "Delete", "Cancel")
            .then((confirmed) => {
                if (confirmed) {
                    deleteRecord(request);
                }
            });
    }
    const openModal = () => {
        setIsModalOpen(!isModalOpen);
    }

    const actionHandler = {
        "CUSTOM_ACTION_CLICK": handleCustomActionClick
    }

    return (
        <>
            <h1 className="account-info-title">
                Total :{paginationRequest.totalCount}
            </h1>
            <MolGrid
                ref={molGridRef}
                configuration={individualMemberTasklistTableConfig}
                dataSource={dataSource}
                allowPagination={true}
                isLoading={isLoading}
                pagination={paginationRequest}
                onPageChange={handlePageChange}
                onActionChange={actionHandler}
            />
            {isModalOpen &&
                <CenterModel
                    modelTitle={'Test'}
                    show={"test"}
                    handleClose={openModal}
                    onUpload={openModal}
                >
                    <h1>Hello</h1>
                </CenterModel>
            }
        </>
    )
}

export default IndividualMemberTable